import { createMemo } from 'solid-js';
import { usePortalCustomizationContext } from '~/portal-customization/PortalCustomizations';

export function useScalekitWatermarkVisibility() {
  const portalCustomizationContext = usePortalCustomizationContext();

  const shouldShowWatermark = createMemo(() => {
    if (!portalCustomizationContext?.customBrandingData) return false;

    const customBranding =
      portalCustomizationContext.customBrandingData.customBranding;

    return !customBranding;
  });

  return {
    shouldShowWatermark
  };
}
